import { React, useEffect } from "react";
import styled from "styled-components";

const PopUpScreen = ({ children, buttons, style }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <PopUpBackground style={style}>
      <PopUpContainer>
        {children}
        <PopUpButtonLayout>
          {buttons.map((button, idx) => {
            return <div key={idx}>{button}</div>;
          })}
        </PopUpButtonLayout>
      </PopUpContainer>
    </PopUpBackground>
  );
};

const PopUpBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 998;
`;

const PopUpContainer = styled.div`
  min-width: 20rem;
  min-height: 10rem;
  background-color: var(--White);
  border-radius: var(--border-radius-16);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 1.5rem;
  z-index: 999;
`;

const PopUpButtonLayout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  gap: 1rem;
`;

export { PopUpScreen };
